namespace Matrix.Data {
    export interface EntityLinkRow {
        EntityName?: string;
        Caption?: string;
        Url?: string;
        Target?: string;
        Icon?: string;
        IconColor?: string;
        DisplayOrder?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace EntityLinkRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'EntityName';
        export const localTextPrefix = 'Data.EntityLink';
        export const lookupKey = 'Data.EntityLink';

        export function getLookup(): Q.Lookup<EntityLinkRow> {
            return Q.getLookup<EntityLinkRow>('Data.EntityLink');
        }
        export const deletePermission = 'DataAdmin:EntityLink';
        export const insertPermission = 'DataAdmin:EntityLink';
        export const readPermission = 'Read:EntityLink';
        export const updatePermission = 'DataAdmin:EntityLink';

        export declare const enum Fields {
            EntityName = "EntityName",
            Caption = "Caption",
            Url = "Url",
            Target = "Target",
            Icon = "Icon",
            IconColor = "IconColor",
            DisplayOrder = "DisplayOrder",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
